import React, { Component } from 'react';
import DataFetcher from '../utils/DataFetcher';
import DeviceRevenuePage from '../components/DeviceRevenuePage';

class DeviceRevenueOfAgent extends Component {
  constructor(props) {
    super(props)
    this.siteId = decodeURIComponent(this.props.match.params.siteId)
  }

  render() {
    const pageProps = {
      fetchSites: (params, callback) => {
        DataFetcher.agentSites(callback)
      },
      fetchRevenue: (params, callback) => {
        DataFetcher.deviceRevenue(params, {
          success: callback
        })
      },
      fetchDeviceTypes: (params, callback) => {
        DataFetcher.deviceTypes(params, {
          success: callback
        })
      },
      defaultSiteId: this.siteId
    }

    return <DeviceRevenuePage {...pageProps}/>
  }
}

export default DeviceRevenueOfAgent;


// WEBPACK FOOTER //
// ./src/modules/DeviceRevenueOfAgent.js